// Function that adds a class to the "sticky add to cart" when the observed element is off the screen
var addClassWhenScrolledPast = function addClassWhenScrolledPast(elementToWatch, elementToAddClass) {
  // We obtain the position of the observed element and the height of the element
  var offset = elementToWatch.offsetTop;
  var elementHeight = elementToWatch.offsetHeight;
  // We obtain the position of the scroll
  var scrollPosition = window.scrollY;
  if (scrollPosition > offset + elementHeight) {
    elementToAddClass.classList.add('sticky-active');
  } else {
    elementToAddClass.classList.remove('sticky-active');
  }
};
var updateQuantitySelector = function updateQuantitySelector() {
  var mainProductInfo = document.querySelector('.product__info-wrapper');
  if (!mainProductInfo) return;
  var mainProductQS = mainProductInfo.querySelector('.buttons__wrap quantity-input input.quantity__input');
  var atcModalQS = document.querySelector('.sticky-product-atc add-to-card-plp quantity-input input.quantity__input');
  if (!atcModalQS) return;
  mainProductQS.addEventListener('change', function () {
    atcModalQS.value = mainProductQS.value;
  });
};
document.addEventListener("DOMContentLoaded", function () {
  var elementToWatch = document.querySelector('.buttons__wrap .product-form .product-form__buttons'),
    elementToAddClass = document.querySelector('.sticky-product-atc .product-container');
  if (elementToWatch && elementToAddClass) {
    window.addEventListener('scroll', function () {
      addClassWhenScrolledPast(elementToWatch, elementToAddClass);
    });
  }

  // Change button atc text
  var stickyAtcButton = document.querySelector('.sticky-product-atc add-to-card-plp span[data-device="mobile"]');
  if (stickyAtcButton) {
    stickyAtcButton.textContent = 'Add to cart';
  }
  updateQuantitySelector();
});